export function hasEntityId(entity: Record<string, any> | null | undefined) {
  const id = entity?.id
  return id !== null && id !== undefined && id !== ''
}
